import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderRo = () => {
    const isMobile = useMediaQuery('(max-width: 767px)')

    return (
        <HighlightedText
            text="Obțineți bonusul dumneavoastră"
            highlights={[{ word: 'bonusul' }, { word: 'dumneavoastră' }]}
            breakAfterWords={isMobile ? ['bonusul'] : []}
            className={styles.text_header}
        />
    )
}

export const TextContentRo = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 ROTIRI GRATUITE"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Bonus', 'ROTIRI']}
            className={styles['text_content--FOURTH']}
        />
    )
}
